import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  cartItems: null,
  loading: false,
  error: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      state.loading = true;
      state.error = null;
    },
    addToCartSuccess(state, action) {
      state.cartItems = action.payload.data.document;
      state.loading = false;
      state.error = null;
    },
    addToCartFailure(state, action) {
      console.log(action.payload);
      state.loading = false;
      state.error = action.payload.message;
    },
    fetchCart(state, action) {
      state.loading = true;
    },
    fetchCartSuccess(state, action) {
      state.cartItems = action.payload.data.document;
      state.loading = false;
    },
    fetchCartFailure(state, action) {
      state.loading = false;
    },
    updateCart(state, action) {
      state.loading = true;
      state.error = null;
    },
    updateCartSuccess(state, action) {
      state.cartItems = action.payload.data.document;
      state.loading = false;
      state.error = null;
    },
    updateCartFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    placeOrder(state, action) {
      state.loading = true;
      state.error = null;
    },
    placeOrderSuccess(state, action) {
      state.cartItems = null;
      state.loading = false;
      state.error = null;
    },
    placeOrderFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = cartSlice;
